module.exports = __webpack_public_path__ + "img/face11.203d1bec.gif";